export const unitTabMixin = {
    props: {
        unit: {
            type: Object,
            default: null
        },
    },
    computed: {
        unitResourcePath: function() { return  `/unit/${this.unit.Id}` },
        unitLogBoekPath: function() { return  this.unitResourcePath + '/logboek/' },
        unitInventarisatiePath: function() { return this.unitResourcePath + '/inventarisatie/' },
        unitServicePath: function() { return this.unitResourcePath + '/service' }
    }
}